var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Lock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 27v-6a12.42 12.42 0 00-3-8.33 12 12 0 00-9.69-4A12.23 12.23 0 0026 21.07V27h-9v36h42V27h-9zm-20-5.93a8.22 8.22 0 017.5-8.38 8 8 0 016.79 3A8.26 8.26 0 0146 20.92V27H30v-5.93zM55 59H21V31h34v28zm-15-6h-4V37h4v16z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Lock.c1f26ecb.svg";
export { SvgJ2Lock as ReactComponent };